import {Home as HomeIcon} from "@mui/icons-material";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import PinDropRoundedIcon from "@mui/icons-material/PinDropRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import ContentPasteOffRoundedIcon from '@mui/icons-material/ContentPasteOffRounded';
import AdminHome from "@Pages/Admin/AdminHomePage/AdminHomePage";
import RegulatoryMemberHome from "../../Pages/RegulatoryMember/HomePage/RegulatoryMemberHome";
import CreateIngredientExit from "../../Pages/RegulatoryMember/IngredientExit/CreateIngredientExit";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import DriveFileMoveRoundedIcon from '@mui/icons-material/DriveFileMoveRounded';

import React from "react";
import CreateNewFolderRoundedIcon from '@mui/icons-material/CreateNewFolderRounded';
import FolderCopyRoundedIcon from '@mui/icons-material/FolderCopyRounded';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FolderDeleteRoundedIcon from '@mui/icons-material/FolderDeleteRounded';
import Notification from "../../Pages/Notification/Notification";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {createIngredientExit} from "../../AppRoutes/DefaultRoutes";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ScienceIcon from '@mui/icons-material/Science';
import RnDMemberHome from "../../Pages/RnDMember/RnDMemberHome/RnDMemberHome";
import MarkEmailUnreadRoundedIcon from "@mui/icons-material/MarkEmailUnreadRounded";
import RuleRoundedIcon from "@mui/icons-material/RuleRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import UsersListing from "../../Pages/Admin/Users/UsersListing";
import CategoriesListing from "../../Pages/Admin/Categories/CategoriesListing";
import RegionsListing from "../../Pages/Admin/Regions.js/RegionsListing";
import PublicIcon from '@mui/icons-material/Public';
import RegulatoryMemberDelegationRequests from "../../Pages/RegulatoryMember/DelegationListing/RegulatoryMemberDelegationListing";
import RnDDelegationRequests from "../../Pages/RnDMember/DelegationListing/RnDDelegationListing";
import ManagerHome from "../../Pages/Manager/ManagerHome";
import ApproverHome from "../../Pages/Approver/ApproverHome";
import RDManagerHome from "../../Pages/RDManager/RDManagerHome/RDManagerHome";
import ContactMailRoundedIcon from "@mui/icons-material/ContactMailRounded";
import MailRoundedIcon from "@mui/icons-material/MailRounded";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import AssignmentLateRoundedIcon from "@mui/icons-material/AssignmentLateRounded";

const AdminMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: DefaultRoutes.home, component: { AdminHome } },
    { text: 'Add User', icon: <PersonAddAltRoundedIcon />, path: DefaultRoutes.users, component: { UsersListing } },
    { text: 'Categories', icon: <CategoryRoundedIcon />, path: DefaultRoutes.categories, component: { CategoriesListing }},
    { text: 'Regions', icon: <PublicIcon />, path: DefaultRoutes.regions, component: { RegionsListing }}

]

const RegulatoryMemberMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: DefaultRoutes.home, component: { RegulatoryMemberHome } },
    { text: 'New Exit Request', icon: <CreateNewFolderRoundedIcon/>, path: DefaultRoutes.createIngredientExit, component: { CreateIngredientExit } },
    { text: 'My Exit Requests', icon: <FolderSpecialIcon/>, path: DefaultRoutes.myActiveReqs },
    { text: 'My Regulatory Exemptions', icon: <ReceiptLongIcon />, path: DefaultRoutes.regulatoryExemptions },
    { text: 'Regulatory Ingredients Hub', icon: <FolderCopyRoundedIcon/>, path: DefaultRoutes.activeReqs },
    { text: 'My Canceled Requests', icon: <DeleteForeverIcon/>, path: DefaultRoutes.myCanceledReqs },
    { text: 'All Canceled Requests', icon: <FolderDeleteRoundedIcon/>, path: DefaultRoutes.canceledReqs },
    { text: 'Delegation Requests', icon: <DriveFileMoveRoundedIcon/>, path: DefaultRoutes.regDelegationRequests,component: {RegulatoryMemberDelegationRequests} },
    { text: 'Extension Requests', icon: <MoreTimeIcon/>, path: DefaultRoutes.regExtensionRequests },
    { text: 'Notifications', icon: <NotificationsIcon/>, path: DefaultRoutes.notifications, component: { Notification } },
]

const RnDMemberMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: DefaultRoutes.home, component: { RnDMemberHome } },
    { text: 'Incoming Requests', icon: <MarkEmailUnreadRoundedIcon />, path: DefaultRoutes.rdIncomingRequests },
    { text: 'My Impact Assessments', icon: <FactCheckRoundedIcon />, path: DefaultRoutes.rdResponses },
    { text: 'Exit Plans', icon: <EditCalendarRoundedIcon />, path: DefaultRoutes.rdExitPlans },
    { text: 'My Regulatory Exemptions', icon: <ReceiptLongIcon />, path: DefaultRoutes.rdExemptions },
    { text: 'Regulatory Ingredients Hub', icon: <FolderCopyRoundedIcon/>, path: DefaultRoutes.activeReqs },

    { text: 'Delegation Requests', icon: <DriveFileMoveRoundedIcon/>, path: DefaultRoutes.rdDelegationRequests,component: {RnDDelegationRequests} },
    { text: 'Extension Requests', icon: <MoreTimeIcon/>, path: DefaultRoutes.rdExtensionRequests },
    { text: 'Notifications', icon: <NotificationsIcon />, path: DefaultRoutes.notifications, component: { Notification } },
]

const ApproverMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: DefaultRoutes.home, component: { ApproverHome } },
    // Plans to Approve - hidden: exit plans no longer require approval.
    // Uncomment to restore when needed again.
    // { text: 'Plans to Approve', icon: <FactCheckRoundedIcon />, path: DefaultRoutes.ApproverPlansToApprove },
    { text: 'Exemptions to Approve', icon: <FactCheckRoundedIcon />, path: DefaultRoutes.ApproverExemptionsToApprove },
    { text: 'Regulatory Exemptions Hub', icon: <ReceiptLongIcon />, path: DefaultRoutes.ApproverExemptionsHub },
    // Pending Approvals - hidden for a simpler, plan-first approval flow.
    // Uncomment to restore when needed again.
    // { text: 'Pending Approvals', icon: <MarkEmailUnreadRoundedIcon />, path: DefaultRoutes.PendingApprovals },
    { text: 'Escalated Requests', icon: <FlagRoundedIcon />, path: DefaultRoutes.ApproverEscalatedRequests },
    { text: 'My Approvals History', icon: <ContactMailRoundedIcon />, path: DefaultRoutes.AssignedRequests },
    { text: 'Regulatory Ingredients Hub', icon: <MailRoundedIcon />, path: DefaultRoutes.AllExitRequests },
    { text: 'Notifications', icon: <NotificationsIcon />, path: DefaultRoutes.notifications, component: { Notification } },
]

const RDManagerMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: DefaultRoutes.home, component: { RDManagerHome } },
    { text: 'Incoming Requests', icon: <MarkEmailUnreadRoundedIcon />, path: DefaultRoutes.rdManagerIncomingRequests },
    { text: 'My Impact Assessments', icon: <FactCheckRoundedIcon />, path: DefaultRoutes.rdManagerResponses },
    { text: 'Exit Plans', icon: <EditCalendarRoundedIcon />, path: DefaultRoutes.rdManagerExitPlans },
    { text: 'My Regulatory Exemptions', icon: <ReceiptLongIcon />, path: DefaultRoutes.rdManagerExemptions },
    { text: 'Regulatory Ingredients Hub', icon: <FolderCopyRoundedIcon/>, path: DefaultRoutes.activeReqs },
    { text: 'Delegation Requests', icon: <DriveFileMoveRoundedIcon/>, path: DefaultRoutes.rdManagerDelegationRequests },
    { text: 'Notifications', icon: <NotificationsIcon />, path: DefaultRoutes.notifications, component: { Notification } },
]

const SupportProviderMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: DefaultRoutes.home },
    { text: 'Pending Approvals', icon: <MarkEmailUnreadRoundedIcon />, path: DefaultRoutes.supportProviderAssignedRequests },
    { text: 'My Approvals History', icon: <ContactMailRoundedIcon />, path: DefaultRoutes.supportProviderAllRequests },
    { text: 'Regulatory Ingredients Hub', icon: <MailRoundedIcon />, path: DefaultRoutes.supportProviderRequestsHub },
    { text: 'Notifications', icon: <NotificationsIcon />, path: DefaultRoutes.notifications, component: { Notification } },
]

const RDCoordinatorMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: DefaultRoutes.home },
    { text: 'Incoming Requests', icon: <ListAltRoundedIcon />, path: DefaultRoutes.rdCoordinatorIncomingRequests },
    { text: 'My Impact Assessments', icon: <AssignmentLateRoundedIcon />, path: DefaultRoutes.rdCoordinatorResponses },
    { text: 'Regulatory Ingredients Hub', icon: <FolderCopyRoundedIcon/>, path: DefaultRoutes.activeReqs },
    { text: 'Notifications', icon: <NotificationsIcon />, path: DefaultRoutes.notifications, component: { Notification } },
]


const SideBarMenuItems = (Role)=>{
    switch (Role) {
        case "ADMIN":
            return AdminMenuItems;
        case "REGULATORY":
            return RegulatoryMemberMenuItems;
        case "R&D":
            return RnDMemberMenuItems;
        case "APPROVER":
        case "MANAGER": // Legacy fallback
            return ApproverMenuItems;
        case "RD_MANAGER":
            return RDManagerMenuItems;
        case "RD_COORDINATOR":
            return RDCoordinatorMenuItems;
        case "SUPPORT_PROVIDER":
        case "MARKETING":
        case "SUPPLY_CHAIN":
            return SupportProviderMenuItems;
        default:
            return [];
    }
}

export default SideBarMenuItems;
